import { tv } from 'tailwind-variants';

export const brainIcon = tv({
  base: ' h-20 w-20 stroke-2 animate-pulse dark:stroke-mono-color-black',
  variants: {
    type: {
      primary: 'stroke-brand-color-primary-pure',
      secondary: 'stroke-brand-color-secondary-pure',
    },
    size: {
      sm: 'h-5 w-5',
      md: 'h-8 w-8',
      lg: 'h-20 w-20',
      xl: 'h-32 w-32',
    },
  },
});
